module.exports = __webpack_public_path__ + "static/media/Buzzwole_gaussian2.6051e21e.png";